import { useState, useCallback, useLayoutEffect } from "react";

function getDimensionObject(node, boundsType) {
  var rect = void 0;

  switch (boundsType) {
    case "BBOX":
      if (!(node instanceof SVGGraphicsElement)) throw new Error();
      rect = node.getBBox();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.x,
        top: rect.y,
        x: rect.x,
        y: rect.y,
        right: rect.right,
        bottom: rect.bottom
      };

    case "CLIENT":
      rect = node.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        top: "x" in rect ? rect.x : rect.top,
        left: "y" in rect ? rect.y : rect.left,
        x: "x" in rect ? rect.x : rect.left,
        y: "y" in rect ? rect.y : rect.top,
        right: rect.right,
        bottom: rect.bottom
      };

    case "OFFSET":
      if (!(node instanceof HTMLElement)) throw new Error();
      return {
        width: node.offsetWidth,
        height: node.offsetHeight,
        top: node.offsetTop,
        left: node.offsetLeft,
        x: node.offsetLeft,
        y: node.offsetTop,
        right: null,
        bottom: null
      };

    case "SCROLL":
      return {
        width: node.scrollWidth,
        height: node.scrollHeight,
        top: node.scrollTop,
        left: node.scrollLeft,
        x: node.scrollLeft,
        y: node.scrollTop,
        right: null,
        bottom: null
      };
  }
}

function useDimensions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$liveMeasure = _ref.liveMeasure,
      liveMeasure = _ref$liveMeasure === undefined ? true : _ref$liveMeasure,
      _ref$boundsType = _ref.boundsType,
      boundsType = _ref$boundsType === undefined ? "CLIENT" : _ref$boundsType,
      _ref$ref = _ref.ref,
      ref = _ref$ref === undefined ? function () {} : _ref$ref;

  var _useState = useState({}),
      dimensions = _useState[0],
      setDimensions = _useState[1];

  var _useState2 = useState(null),
      node = _useState2[0],
      setNode = _useState2[1];

  var localRef = useCallback(function (node) {
    setNode(node);

    if (typeof ref === "function") {
      ref(node);
    } else {
      ref.current = node;
    }
  }, []);
  useLayoutEffect(function () {
    if (node) {
      var measure = function measure() {
        return window.requestAnimationFrame(function () {
          return setDimensions(getDimensionObject(node, boundsType));
        });
      };

      measure();

      if (liveMeasure) {
        window.addEventListener("resize", measure);
        window.addEventListener("scroll", measure);
        return function () {
          window.removeEventListener("resize", measure);
          window.removeEventListener("scroll", measure);
        };
      }
    }
  }, [node]);
  return [localRef, dimensions, node];
}

export default useDimensions;